// @flow
import styled from 'styled-components';

const InputField = styled.input`
  display: flex;
  flex-direction: column;
  width: 280px;
  height: 50px;
  border-radius: 3px;
  background-color: ${props => props.theme.slateGrey10};
  box-sizing: border-box;
  padding-left: 16px;
  outline: none;
  border: none;
  margin-top: 20px;
  width: 100%;
  font-family: Montserrat-Book;
  font-size: 16px;
  color: ${props => props.theme.battleshipGrey};

  ::placeholder {
    font-family: Montserrat-Book;
    font-size: 16px;
    color: ${props => props.theme.battleshipGrey};
  }
`;

export default InputField;
